<template>
  <div
    class="sc-launcher text-white rounded-full shadow-none transition-shadow duration-200 ease-in-out cursor-pointer flex items-center justify-center"
    :style="styles"
    :class="langConfigDefaultButtonTitle ? 'wide' : 'rounded'"
  >

    <div class="sc-icon-wrapper h-full w-full flex items-center justify-center">
      <img v-if="buttonIconSrc"
           :src="buttonIconSrc"
           height="30"
           width="30"
           alt="button icon"
      />
      <messages-icon v-else/>
    </div>

    <span v-if="langConfigDefaultButtonTitle" class="whitespace-nowrap">
      {{ langConfigDefaultButtonTitle }}
    </span>
  </div>
</template>

<script>
import MessagesIcon from '@/assets/images/icons/chat-widget/messagesIcon.vue'

export default {
  name: 'ChatLauncher',

  components: { MessagesIcon },

  props: {
    themeConfig: {
      type: Object,
      required: true
    },
    langConfig: {
      type: Object,
      required: true
    },
    buttonIconCache: {
      type: File | String
    },
    buttonIcon: {
      type: String
    }
  },

  computed: {
    styles() {
      return {
        fontFamily: this.themeConfig.font,
        background: this.themeConfig.launcher.bg,
        marginBottom: this.themeConfig.launcher.marginBottom || 'auto',
        fontWeight: this.themeConfig.launcher.fontWeight || 600
      }
    },

    buttonIconSrc() {
      const buttonIcon = this.buttonIconCache || this.themeConfig.launcher.imageUrl
      if (!buttonIcon) return null

      if (buttonIcon instanceof File) {
        return URL.createObjectURL(buttonIcon)
      }

      return buttonIcon
    },

    langConfigDefaultButtonTitle() {
      return this.langConfig?.default?.buttonTitle
    }
  }
}
</script>
